export default __webpack_public_path__ + "static/fixedMenuTelegramIcon-3cb76f3d92828f93d00b74e1436a2796.svg";